/* global google */
$(
	function() {
		function initialize() {

			const map = new google.maps.Map(
				document.getElementById( "current_location" ),
				{
					center: {lat: 44.968032, lng: -93.259883},
					zoom: 6,
				}
			);

			var markers = new Array();
			/**var infowindow = new google.maps.InfoWindow({
				maxWidth: 160,
			});**/

			// eslint-disable-next-line no-undef
			var stores_injected = stores;

			for (var i = 0; i < stores_injected.length; i++) {
				var lat = stores_injected[i]['location']['google_maps']['lat'];
				var lng = stores_injected[i]['location']['google_maps']['lng'];

				if ( ! lat) {
					continue;
				}

				var title = stores_injected[i]['location']['title'];
				//var address = stores_injected[i]['location']['address'];

				var marker = new google.maps.Marker(
					{
						position: new google.maps.LatLng( lat, lng ),
						title: title,
						map: map,
						//icon: icons[iconCounter]
					}
				);
				markers.push( marker );
			}

			// Autocenter with given markers
			//  Create a new viewpoint bound
			var bounds = new google.maps.LatLngBounds();
			//  Go through each...
			for (var j = 0; j < markers.length; j++) {
				bounds.extend( markers[j].position );
			}
			//  Fit these bounds to the map
			map.setCenter( bounds.getCenter() );
			map.setZoom( 10 );
		}
		initialize();
	}
);



// WEBPACK FOOTER //
// ./scripts/mulberrys/page-map.js